import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { map, Observable, shareReplay } from "rxjs";
import { ProyectosService } from "src/app/proyectos/proyectos.service";
import { Periodicidad } from "src/app/shared/model/gestion-proyectos/riesgos/periodicidad.model";
import { Riesgos } from "src/app/shared/model/gestion-proyectos/riesgos/riesgo.model";
import { UrlConstantes } from "src/app/utilerias/constantes/urlconstantes";

// Angular core y formularios
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// Angular Material
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatStepperModule } from '@angular/material/stepper';

// Módulo de búsqueda dentro de mat-select
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

@Component({
  selector: 'app-controles-riesgo',
  templateUrl: './controles-riesgo.component.html',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxMatSelectSearchModule,
    MatStepperModule
  ]
})
export class ControlesRiesgoComponent implements OnInit {

  @Input() riesgo: Riesgos;
  @Input() controlesRiesgoGroup: FormGroup;   // ⬅️ agregado para que Angular lo reconozca
  @Output() agregarRiesgo = new EventEmitter<Riesgos>();

  primerGrupo: FormGroup; // lo conservamos porque ya lo usabas internamente
  readonly periodicidad$: Observable<Periodicidad[]>;

  constructor(
    private fb: FormBuilder,
    private service: ProyectosService
  ) {
    this.periodicidad$ = this.obtenerPeriodicidad();
  }

  ngOnInit() {
    // inicializamos este grupo si no viene desde el padre
    if (!this.controlesRiesgoGroup) {
      this.controlesRiesgoGroup = this.fb.group({
        fechaCtrl: ['', Validators.required],
        periodicidadCtrl: ['', Validators.required],
        accionesSeguirCtrl: ['', Validators.required],
        responsableRecursoCtrl: ['', Validators.required]
      });
    }

    // lo mismo para primerGrupo si lo necesitas
    if (!this.primerGrupo) {
      this.primerGrupo = this.fb.group({
        nombreProyecto: ['', Validators.required]
      });
    }

  }

  private obtenerPeriodicidad(): Observable<Periodicidad[]> {
    return this.service.consultaGeneral(UrlConstantes.consultaPeriodicidad).pipe(
      map((res) => res?.list ?? []),
      shareReplay({ bufferSize: 1, refCount: true })
    );
  }

  guardarRiesgo() {
    if (this.controlesRiesgoGroup.valid) {
      this.agregarRiesgo.emit(this.riesgo);
    }
  }
}
